var Assam = "อัสสัม";
var Bihar = "พิหาร";
var Chandigarh = "จัณฑีครห์";
var Chhattisgarh = "ฉัตติสครห์";
var Delhi = "เดลี";
var Goa = "กัว";
var Gujarat = "คุชราฏ";
var Haryana = "หรยาณา";
var Jharkhand = "ฌาร์ขันท์";
var Karnataka = "กรณาฏกะ";
var Kerala = "เกรละ";
var Lakshwadeep = "ลักษทวีป";
var Maharashtra = "มหาราษฎระ";
var Manipur = "มณีปุระ";
var Meghalaya = "เมฆาลัย";
var Mizoram = "มิโซรัม";
var Nagaland = "นากาแลนด์";
var Orrisa = "โอฑิศา";
var Puducherry = "พูดูเชอร์รี";
var Punjab = "ปัญจาบ";
var Rajasthan = "ราชาสถาน";
var Sikkim = "สิกขิม";
var Telangana = "เตลังคานา";
var Tripura = "ตรีปุระ";
var Uttrakhand = "อุตตราขัณฑ์";
var INStates = {
	"Andaman and Nicobar Islands": "หมู่เกาะอันดามันและนิโคบาร์",
	"Andhra Pradesh": "อานธรประเทศ",
	"Arunachal Pradesh": "อรุณาจัลประเทศ",
	Assam: Assam,
	Bihar: Bihar,
	Chandigarh: Chandigarh,
	Chhattisgarh: Chhattisgarh,
	"Dadra & Nagar Haveli": "ดาดราและนครหเวลี",
	"Daman & Diu": "ดามันและดีอู",
	Delhi: Delhi,
	Goa: Goa,
	Gujarat: Gujarat,
	Haryana: Haryana,
	"Himachal Pradesh": "หิมาจัลประเทศ",
	"Jammu and Kashmir": "จัมมูและแคชเมียร์",
	Jharkhand: Jharkhand,
	Karnataka: Karnataka,
	Kerala: Kerala,
	Lakshwadeep: Lakshwadeep,
	"Madhya Pradesh": "มัธยประเทศ",
	Maharashtra: Maharashtra,
	Manipur: Manipur,
	Meghalaya: Meghalaya,
	Mizoram: Mizoram,
	Nagaland: Nagaland,
	Orrisa: Orrisa,
	Puducherry: Puducherry,
	Punjab: Punjab,
	Rajasthan: Rajasthan,
	Sikkim: Sikkim,
	"Tamil Nadu": "ทมิฬนาดู",
	Telangana: Telangana,
	Tripura: Tripura,
	"Uttar Pradesh": "อุตตรประเทศ",
	Uttrakhand: Uttrakhand,
	"West Bengal": "เบงกอลตะวันตก"
};

export { Assam, Bihar, Chandigarh, Chhattisgarh, Delhi, Goa, Gujarat, Haryana, Jharkhand, Karnataka, Kerala, Lakshwadeep, Maharashtra, Manipur, Meghalaya, Mizoram, Nagaland, Orrisa, Puducherry, Punjab, Rajasthan, Sikkim, Telangana, Tripura, Uttrakhand, INStates as default };
